// our own corporate colors, replacement for standard CSS ones, sorted by popularity
export const FILTER_COLOR_BOXES: {
  [key: string]: {
    hexCode: string;
    sorting: number;
  };
} = {
  black: { hexCode: '#000000', sorting: 1 },
  white: { hexCode: '#fff', sorting: 2 },
  beige: { hexCode: '#efe6dc', sorting: 3 },
  grey: { hexCode: '#7e7e7e', sorting: 4 },
  blue: { hexCode: '#337eae', sorting: 5 },
  green: { hexCode: '#26a877', sorting: 6 },
  brown: { hexCode: '#87684f', sorting: 7 },
  red: { hexCode: '#cb344b', sorting: 8 },
  pink: { hexCode: '#eb167d', sorting: 9 },
  'multi-colored': {
    hexCode: 'linear-gradient(45deg, rgb(0, 165, 223), rgb(243, 239, 21), rgb(223, 19, 44))',
    sorting: 10,
  },
  gold: { hexCode: '#b27d10', sorting: 11 },
  silver: { hexCode: '#bebebe', sorting: 12 },
  'light blue': { hexCode: '#b3d8e8', sorting: 13 },
  purple: { hexCode: '#8f2598', sorting: 14 },
  khaki: { hexCode: '#5e5c45', sorting: 15 },
  orange: { hexCode: '#f46335', sorting: 16 },
  yellow: { hexCode: '#eeea48', sorting: 17 },
  olive: { hexCode: '#9db27e', sorting: 18 },
  turquoise: { hexCode: '#60c7c3', sorting: 19 },
  cream: { hexCode: '#FFFDD0', sorting: 20 },
  natural: { hexCode: '#E5D3BF', sorting: 21 },
};

const COLORS_DE = {
  took: 0,
  timed_out: false,
  _shards: {
    total: 1,
    successful: 1,
    skipped: 0,
    failed: 0,
  },
  hits: {
    total: {
      value: 19,
      relation: 'eq',
    },
    max_score: 1.0,
    hits: [
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'beige',
        _score: 1.0,
        _source: {
          id: 'beige',
          name: 'beige',
          url_name: 'beige',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'green',
        _score: 1.0,
        _source: {
          id: 'green',
          name: 'gr\u00fcn',
          url_name: 'gruen',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'grey',
        _score: 1.0,
        _source: {
          id: 'grey',
          name: 'grau',
          url_name: 'grau',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'brown',
        _score: 1.0,
        _source: {
          id: 'brown',
          name: 'braun',
          url_name: 'braun',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'blue',
        _score: 1.0,
        _source: {
          id: 'blue',
          name: 'blau',
          url_name: 'blau',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'red',
        _score: 1.0,
        _source: {
          id: 'red',
          name: 'rot',
          url_name: 'rot',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'orange',
        _score: 1.0,
        _source: {
          id: 'orange',
          name: 'orange',
          url_name: 'orange',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'yellow',
        _score: 1.0,
        _source: {
          id: 'yellow',
          name: 'gelb',
          url_name: 'gelb',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'pink',
        _score: 1.0,
        _source: {
          id: 'pink',
          name: 'pink',
          url_name: 'pink',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
      {
        _index: 'color_tags',
        _type: '_doc',
        _id: 'turquoise',
        _score: 1.0,
        _source: {
          id: 'turquoise',
          name: 't\u00fcrkis',
          url_name: 'tuerkis',
          __version_key__: '2024-06-26T09:35:01.181102',
        },
      },
    ],
  },
};

//map colors like where url_name is the key and value is the _id
export const COLORS_DE_EN_MAPPING = COLORS_DE.hits.hits.reduce((acc, hit) => {
  acc[hit._source.url_name] = hit._source.id;
  return acc;
}, {} as { [key: string]: string });
